import React, { Component, PropTypes } from "react";
import { Modal, Button } from "react-bootstrap";
import SignInForm from "./SignInForm";
import "./SignIn.less";
import SessionActions from "../../../actions/SessionActions";

class SignIn extends Component {
  constructor() {
    super();
  }

  static propTypes = {
    open: PropTypes.bool.isRequired,
  };

  render() {
    return (
      <Modal show={this.props.open} onHide={SignIn._handleCloseSignInPopup}>
        <Modal.Header closeButton={true}>
          <Modal.Title>Sign In</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SignInForm />
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button type="button" className="login-with-google-btn">
              Sign in with Google
            </button>
            <p>
              <a
                className="btn btn-danger google-icon"
                href="/api/google/login"
                style={{ width: "100%" }}
              >
                Sign In with Google
              </a>
            </p>
          </div>
          <div className="text-center">
            <span>Not a user? </span>
            <a
              style={{ cursor: "pointer" }}
              onClick={SignInForm._handleSignUpPopup}
            >
              Sign Up
            </a>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }

  static _handleCloseSignInPopup() {
    SessionActions.closeSignInPopup();
  }
}

export default SignIn;
